  export const serviceDocs = () =>
  [
    {
      label: "Παραστατικό Παροχής Υπηρεσιών",
      fileCode: 'INVOICE',
      id: 'INVOICE',
      multiple: false,
      fileLimit: 10,
      required: true,
    },
    {
      label: "Βεβαίωση Εγκατάστασης",
      fileCode: 'SERVICE_CERTIFICATE',
      id: 'SERVICE_CERTIFICATE',
      multiple: false,
      fileLimit: 10,
      required: true,
    },
    {
      label: "Άλλο Έγγραφο",
      fileCode: 'OTHER',
      id: 'OTHER',
      multiple: false,
      fileLimit: 10
    },
  ].filter(item => item);